import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { LoadingService } from 'src/app/services/loading.service';
import { TagPage } from 'src/app/store/actions/ui.actions';
import { OnboardingProductsStore } from 'src/app/store/store';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sucursal-derivation',
  templateUrl: './sucursal-derivation.component.html',
  styleUrls: ['../../../global.scss', './sucursal-derivation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SucursalDerivationComponent implements OnInit {
  staticAssetsUrl = environment.staticScripts.staticAssets;

  constructor(
    public loadingService: LoadingService,
    private store: Store<OnboardingProductsStore.AppState>
  ) { }

  ngOnInit() {
    document.getElementById('white-container').style.display = 'block';
    setTimeout(() => {
      this.loadingService.loading = false;
    }, 100);
    this.store.dispatch(TagPage({text: 'sucursalDerivation'}));
  }

  checkOffices() {
    window.open('https://www.bancofalabella.pe/sucursales', '_blank');
  }

}
